import { http } from './http';
import { LoginResponse } from '../types';

const BASE = '/v1/instructor-auth';

/** Demande un lien magique de connexion (première connexion / sans mot de passe). */
export async function requestMagicLink(email: string): Promise<void> {
  await http.post(`${BASE}/request-link`, { email });
}

/** Vérifie un lien magique (token de l'URL) → session moniteur. */
export async function verifyMagicLink(token: string): Promise<LoginResponse> {
  const { data } = await http.post<LoginResponse>(`${BASE}/verify`, { token });
  return data;
}

/** Connexion par email + mot de passe → session moniteur. */
export async function loginWithPassword(
  email: string,
  password: string,
): Promise<LoginResponse> {
  const { data } = await http.post<LoginResponse>(`${BASE}/login`, {
    email,
    password,
  });
  return data;
}

/** Définit ou modifie le mot de passe du moniteur connecté. */
export async function setPassword(
  newPassword: string,
  currentPassword?: string,
): Promise<void> {
  await http.post(`${BASE}/set-password`, { newPassword, currentPassword });
}
